import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { PrnCommentPopover } from "./prn-comment-popover";

@NgModule({
  declarations: [PrnCommentPopover],
  imports: [IonicPageModule.forChild(PrnCommentPopover)],
})
export class PrnCommentPopoverModule {}



// WEBPACK FOOTER //
// ./src/pages/assessment/prn-comment-popover/prn-comment-popover.module.ts